import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../actionTypes';

/** @typedef {Array<import('modules/medias/types/abstract-media').AbstractMedia>} State */

/** @type {State} */
const initialState = [];

/**
 * @param {State} state
 * @param {import('../../../types').FetchDefaultClippingMediaSuccessAction} action
 * @returns {State}
 */
const setDefaultMedia = (state, { payload }) => payload;

/**
 * @returns {State}
 */
const setInitialState = () => initialState;

export default createReducer(initialState, {
  [types.FETCH_FLEETBACK_MEDIAS_CLIPPING_REQUEST]: setInitialState,
  [types.FETCH_FLEETBACK_MEDIAS_CLIPPING_SUCCESS]: setDefaultMedia,
});
